import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import { Box, Grid, InputAdornment, Typography } from "@mui/material";
import { useEquipment, useUser } from "@services/servicesGenericsTables";
import dayjs from "dayjs";
import React, { useEffect, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";
import TableCalcinationForm from "./tableCalcination";
import TableDryingForm from "./tableDrying";
import useFilterSamplingProcedure from "@app/hooks/useFilterSamplingProcedure";
import { formatDateOrNow } from "@app/utils/formatDate";
import useAuth from "@app/context/AuthContext";

const Calcination = () => {
  const form = useFormContext();
  const filterSamplingProcedureList = useFilterSamplingProcedure("CALCI");
  const [calcinationValue, setCalcinationValue] = useState<number>(-1);
  const [dryingValue, setDryingValue] = useState<number>(-1);
  const { user } = useAuth();

  const { equipmentList } = useEquipment();
  const { userList } = useUser();
  const watchCapsules = form.watch("capsules_number_calcination");

  const secoCalcinado = useMemo(() => {
    if (calcinationValue > 0 && dryingValue > 0) {
      return (dryingValue / calcinationValue).toFixed(4);
    }
    return 0;
  }, [calcinationValue, dryingValue]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!form.getValues("processing_analyst_calcination")) {
      form.setValue("processing_analyst_calcination", user);
    }
    if (!form.getValues("processing_date_time_calcination")) {
      form.setValue("processing_date_time_calcination", formatDateOrNow());
    }

    if (!form.getValues("processing_date_time_end_calcination")) {
      form.setValue("processing_date_time_end_calcination", formatDateOrNow());
    }

    if (!form.getValues("processing_procedure_calcination")) {
      form.setValue(
        "processing_procedure_calcination",
        filterSamplingProcedureList[0] || undefined
      );
    }
    form.setValue("dry_calcination", secoCalcinado);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    form.setValue("dry_calcination", secoCalcinado);
  }, [secoCalcinado]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Grid item xs={12} my={2}>
        <Typography variant="tagText">{"Calcinación"}</Typography>
      </Grid>
      <ResponsiveFormContainer columns={6} mt={1}>
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_analyst_calcination"))}
          name="processing_analyst_calcination"
          options={userList}
          label="Seleccione un analista"
          getOptionLabel={(option) => option.username || ""}
          validation={{ required: "El analista es requerido" }}
        />
        <MAutocomplete
          key={JSON.stringify(
            form.getValues("processing_procedure_calcination")
          )}
          name="processing_procedure_calcination"
          options={filterSamplingProcedureList}
          label="Procedimiento MLPMA"
          getOptionLabel={(option) => `${option.numop}` || ""}
          validation={{
            required:
              filterSamplingProcedureList.length > 0
                ? "El procedimiento MLPMA es requerido"
                : false,
          }}
        />
        <MAutocomplete
          key={JSON.stringify(
            form.getValues("processing_equipment_calcination")
          )}
          name="processing_equipment_calcination"
          options={equipmentList}
          label="Seleccione un Equipo"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}` || ""
          }
          validation={{ required: "El equipo es requerido" }}
          multiple={true}
        />
        <MDatePicker
          name="processing_date_time_calcination"
          pickerType="datetime"
          label="Fecha y hora Inicio"
          validation={{ required: "La fecha y hora de inicio es requerida" }}
          maxDate={
            dayjs(form.watch("processing_date_time_end_calcination")) || null
          }
        />
        <MDatePicker
          name="processing_date_time_end_calcination"
          pickerType="datetime"
          label="Fecha y hora Fin"
          minDate={
            dayjs(form.watch("processing_date_time_calcination")) || null
          }
        />
        <MTextField
          key={JSON.stringify(form.getValues("capsules_number_calcination"))}
          name="capsules_number_calcination"
          placeholder="Nº de cápsulas"
          label="Nº de cápsulas"
          type="number"
          fullWidth
          validation={{ required: "El número de cápsulas es requerido" }}
        />
      </ResponsiveFormContainer>
      {watchCapsules > 0 && (
        <>
          <TableDryingForm
            count={watchCapsules}
            setDryingValue={setDryingValue}
            tara={form
              .watch("rowsCurvaCalcination")
              ?.find((row) => row.id === "calcinacion_1")}
          />
          <TableCalcinationForm
            count={watchCapsules}
            setCalcinationValue={setCalcinationValue}
          />
          <Box mt={3} sx={{ width: "30%" }}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Seco/Calcinado:
              <MTextField
                name="dry_calcination"
                label="Seco/Calcinado"
                type="number"
                fullWidth
                disabled
              />
            </Typography>
          </Box>
        </>
      )}
    </>
  );
};

export default Calcination;
